//
<template>
<p class="back-button-container" @click="trackClick()">
  <router-link :to="to" class="back-button">{{$t('GLOBAL.BACK')}}</router-link>
</p>
</template>
<script>
export default {
  props: {
    /**
     * the route where the navigation go
     */
    to: {
      type: String,
    },
    trackAction: {
      type: String,
      default: null,
    },
    trackLabel: {
      type: String,
      default: null,
    }

  },
  methods: {
    trackClick() {
      if(this.trackAction && this.trackLabel){
        this.fireTrackEvent(this.trackAction, this.trackLabel)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../scss/colors";

  .back-button {
    color: $on-surface;

    &-container {
      text-align: center;
      margin: 16px 0;
    }
  }
</style>
